import React from 'react';
import { string } from 'prop-types';

import quotation from './images/ic_quotation.svg';

import styles from './Testimonial.scss';

function Testimonial({ title, imageUrl, descr, name, city }) {
  return (
    <figure className={styles.root}>
      <img src={imageUrl} className={styles.image} />
      <figcaption className={styles.infoBlock}>
        <img src={quotation} className={styles.quotation} />
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.descr}>{descr}</p>
        <div className={styles.nameInfo}>
          <h6>{name}</h6>
          <h6 className={styles.city}>{city}</h6>
        </div>
      </figcaption>
    </figure>
  );
}

Testimonial.propTypes = {
  city: string.isRequired,
  descr: string.isRequired,
  imageUrl: string.isRequired,
  name: string.isRequired,
  title: string.isRequired,
};

export default Testimonial;



// WEBPACK FOOTER //
// ./app/containers/Premium/components/TestimonialBlock/components/Testimonial/Testimonial.jsx